import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 1em 1em 1em 1em;
    width: 97%;
    margin: auto;
    margin-top: 30px;
    border-radius: ${theme.border.radius.small};
    background-color: ${theme.colors.white};
  `}
`
